<template>
  <div class="tw-min-h-screen tw-bg-gray-100">
    <div class="tw-flex tw-items-center tw-min-h-screen tw-justify-center">
      <base-card shadow class="tw-w-full sm:tw-w-3/5 lg:tw-w-1/3 tw-max-w-lg">
        <div class="tw-flex tw-justify-center tw-mx-auto tw-pt-4 tw-mb-8">
          <img class="tw-w-40" src="@/assets/images/predictile-logo-square.png" />
        </div>
        <div v-if="isLoading">
          <div class="tw-mb-4 tw-text-center tw-text-xl tw-font-light">Confirming Email Address...</div>
          <p class="tw-text-center tw-mt-8">
            <base-spinner />
          </p>
        </div>
        <div v-if="!isLoading">
          <div class="tw-mb-2 tw-text-center tw-text-xl tw-font-light">Confirm Email Address</div>
          <p class="tw-text-sm tw-text-center">{{ message }}</p>
          <div v-if="success" class="tw-text-right tw-pb-5">
            <base-button type="primary" size="lg" class="tw-mt-6 tw-w-full" @click="href('/signin')">
              Sign in
            </base-button>
          </div>
        </div>
      </base-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserConfirmEmailAddressView",
  props: ["userId"],
  data() {
    return {
      isLoading: null,
      success: null,
      message: null,
    };
  },
  computed: {
    expiration() {
      return this.$route.query.exp;
    },
    code() {
      return this.$route.query.code;
    },
    businessInviteAccept() {
      return this.$route.query.businessInviteAccept;
    },
    businessId() {
      return this.$route.query.businessId;
    },
    confirm() {
      return this.$route.query.confirm;
    },
  },
  mounted() {
    this.isLoading = true;
    this.$axios
      .post(`/users/${this.userId}/confirm/email`, { expiration: this.expiration, code: this.code })
      .then(() => {
        this.isLoading = false;
        this.success = true;
        if (this.businessInviteAccept == "true") {
          this.$router.push(`/businesses/${this.businessId}/user-invites/accept?a=true&i=${this.$route.query.i}&e=${this.$route.query.e}`);
        } else {
          this.message = "Your email has been confirmed. You may now sign in.";
        }
      })
      .catch((err) => {
        this.isLoading = false;
        this.message = err && err[0] ? err[0].message : "An unknown error occured.";
        this.success = false;
      });
  },
  methods: {
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
